// 请在此处修改服务器重定向地址
const baseUrl = process.env.NODE_ENV == "production" ? "https://q4abbz86h7.execute-api.cn-northwest-1.amazonaws.com.cn/dev" : "https://q4abbz86h7.execute-api.cn-northwest-1.amazonaws.com.cn/dev"

const fileServeUrl = process.env.NODE_ENV == "production" ? "http://192.168.28.28:8089" : "" // TODO : need align to deployment environment
// const fileServeUrl = process.env.NODE_ENV == "production" ? "https://service.ecosystemtest.carrier.com" : "" // TODO : need align to deployment environment

// 连接WIFI “SRDC-5G”：          "http://192.168.168.23:8013" "http://192.168.28.28:8013"
// AWS云：                       "http://18.138.15.157:8012"
// Liang Di个人电脑：            "http://192.168.28.47:8050"
// 本人个人电脑：                 "http://192.168.28.41:8050"

exports.serviceConfig = {
  name: "VRF Retrofit",
  version: "V1.0.1",
  mode: process.env.NODE_ENV,
  fileServeUrl,
  baseUrl,
  root: process.env.NODE_ENV == "production" ? baseUrl : "/api"
}



// WEBPACK FOOTER //
// ./src/config/index.js